import styled from "styled-components";
import { tColumn } from "../../Models/Column";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";

function columnSize(props: tColumn, size?: number) {
  const defaultCase = props.span ? `span ${props.span}` : "auto";

  return size ? `span ${size}` : defaultCase;
}

export const Column = styled.div<tColumn>`
  grid-column: ${(props) => columnSize(props, props.span)};

  ${mediaQuery[Screen.xs]} {
    grid-column: ${(props) => columnSize(props, props.xs)};
  }

  ${mediaQuery[Screen.sm]} {
    grid-column: ${(props) => columnSize(props, props.sm)};
  }

  ${mediaQuery[Screen.md]} {
    grid-column: ${(props) => columnSize(props, props.md)};
  }

  ${mediaQuery[Screen.lg]} {
    grid-column: ${(props) => columnSize(props, props.lg)};
  }

  ${mediaQuery[Screen.xxl]} {
    grid-column: ${(props) => columnSize(props, props.xxl)};
  }
`;
